// ─── Admin Settings Endpoints ─────────────────────────────────────────────────

// Admin Users
export const API_GET_ALL_ADMINS = '/admin/getAllAdminList/';
export const API_EDIT_ADMIN = '/admin/editAdmin/';
export const API_ADD_ADMIN = '/admin/addAdmin/';
export const API_GET_ADMIN = '/admin/getUserById/';
export const API_DELETE_ADMIN = '/admin/deleteAdminUser/';
export const API_TOGGLE_SUPPORT_CHAT = '/admin/toggleSupportChat';
export const API_GET_ADMIN_PROFILE = '/admin/getAdminProfile';
export const API_UPLOAD_SUPPORT_MEDIA = '/admin/uploadMedia';

// Basic / Social / App Settings
export const API_UPDATE_ADMIN_PASSWORD = '/adminSetting/changePassword/';
export const API_GET_BASIC_SETTINGS = '/adminSetting/getBasicsettinginfo';
export const API_UPDATE_BASIC_SETTINGS = '/adminSetting/basicAppSetting';
export const API_UPDATE_NOTIFICATION_SETTINGS = '/adminSetting/notificationSettingUpdate/';
export const API_UPDATE_SOCIAL_SETTINGS = '/adminSetting/basicSocialSetting';

// Installation / Integration Settings
export const API_INSTALLATION_SETTINGS = '/adminSetting/getConfigInfo';
export const API_UPDATE_SMS_INSTALLATION_SETTINGS = '/adminSetting/twilioUpdate';
export const API_UPDATE_PAYMENT_INSTALLATION_SETTINGS = '/adminSetting/PaymentConfigUpdate';
export const API_UPDATE_MAILGUN_INSTALLATION_SETTINGS = '/adminSetting/MailGunConfigUpdate';
export const API_UPDATE_ANDROID_INSTALLATION_SETTINGS = '/adminSetting/AndroidAppUrlUpdate';
export const API_UPDATE_IOS_INSTALLATION_SETTINGS = '/adminSetting/IOSAppURLUpdate';

// Mail Templates
export const API_GET_MAIL_TEMPLATES = '/adminSetting/getMailTitle/';
export const API_GET_MAIL_TEMPLATE = '/adminSetting/getMailTemplateById/';
export const API_ADD_MAIL_TEMPLATE = '/adminSetting/addMailTemplate/';
export const API_EDIT_MAIL_TEMPLATE = '/adminSetting/editMailTemplate/';
export const API_GET_MAILTEMPLATE = '/adminSetting/getMailTitle';
export const API_UPDATE_MAILTEMPLATE = '/adminSetting/editMailTemplate';

// SMS Templates
export const API_GET_SMS_TEMPLATES = '/adminSetting/getSmsTemplate/';
export const API_GET_SMS_TEMPLATE = '/adminSetting/getSmsTemplateById/';
export const API_ADD_SMS_TEMPLATE = '/adminSetting/addSmsTemplate/';
export const API_EDIT_SMS_TEMPLATE = '/adminSetting/editSmsTemplate/';
export const API_GET_SMSTEMPALTE = '/adminSetting/getSmsTemplate';
export const API_UPDATE_SMSTEMPALTE = '/adminSetting/editSmsTemplate';
